import { DoBootstrap, Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StepElement } from './step.component';
import { createCustomElement } from '@angular/elements';
import { IconModule } from '@bazis/shared/components/web/icon/icon.module';

@NgModule({
    declarations: [StepElement],
    imports: [CommonModule, IconModule],
    exports: [StepElement],
})
export class StepModule implements DoBootstrap {
    constructor(private injector: Injector) {}

    ngDoBootstrap(): void {
        const el = createCustomElement(StepElement, {
            injector: this.injector,
        });

        customElements.define('bazis-step', el);
    }
}
